import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { UPDropdownItem } from 'components/dropdown';
import {
  DocumentFollowUpEmployeeItem,
  DocumentFollowUpEmployeesRequest,
} from 'types/reporting/DocumentFollowUpEmployees';
import DocumentFollowUpFilter from 'types/reporting/DocumentFollowUpFilter';
import ReportingFilter from 'types/reporting/ReportingFilter';
import ReportingResult from 'types/reporting/ReportingResult';

export const getReportData = async (filters: ReportingFilter): Promise<ReportingResult> => {
  const response: AxiosResponse<any> = await getApi().post(`Reporting/Get`, filters);
  return response.data;
};

export const getDocumentFollowUpCategories = async (): Promise<UPDropdownItem[]> => {
  const response: AxiosResponse<UPDropdownItem[]> = await getApi().get(`Reporting/DocumentFollowUpCategories`);
  return response.data;
};

export const getDocumentFollowUpEmployees = async (
  request: DocumentFollowUpEmployeesRequest,
): Promise<DocumentFollowUpEmployeeItem[]> => {
  const response: AxiosResponse<DocumentFollowUpEmployeeItem[]> = await getApi().post(
    `Reporting/DocumentFollowUpEmployees`,
    request,
  );
  return response.data;
};

export const getDocumentFollowUpData = async (filter: DocumentFollowUpFilter): Promise<ReportingResult> => {
  const response: AxiosResponse<any> = await getApi().post(`Reporting/DocumentFollowUp`, filter);
  return response.data;
};

export const downloadReportData = async (filters: ReportingFilter, ids: string[]): Promise<Blob> => {
  const response: AxiosResponse<Blob> = await getApi().post(
    `Reporting/Download`,
    { searchModel: filters, ids },
    { responseType: 'blob' },
  );
  return response.data;
};
